<template>
  <AppMainFormCard
    :isLoading="isLoading"
    :tituloTela="tituloTela"
    :canDelete="isEditing"
    @delete="beforeDeleteRegistro"
    @add="novoRegistro"
    :isSearch="true"
    @search="goSearch"
  >
    <v-form v-model="isFormValid" ref="form">
      <v-layout row justify-center>
        <v-flex class="item" xs12 md11 ma-5>
          <h3>
            <b>Dados da Ração</b>
          </h3>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-flex class="item" xs11 md11 lg11>
          <v-text-field
            :rules="[campoObrigatorio]"
            v-model.trim="registro.nmRacao"
            label="Nome"
            outlined
            clearable
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex class="item" xs11 md7 lg7>
          <v-text-field
            :rules="[campoObrigatorio, tamanhoMaximoTrinta]"
            v-model.trim="registro.cdItem"
            label="Código na empresa"
            outlined
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex class="item" xs11 md4 lg4>
          <v-autocomplete
            :rules="[campoSelectObrigatorio]"
            v-model="statusAtual"
            :items="listaStatus"
            color="primary"
            item-text="dsStatus"
            item-value="csStatus"
            label="Status"
            no-data-text="Nenhum registro"
            outlined
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row justify-center v-if="registro.idRacao > 0">
      <v-flex sm2 xs2 md1>
        <DialogCadastroMedicamento
          @inserted="selectMedicamentoInserted"
          :dialog="dialogMedicamento"
          :idRacao="registro.idRacao"
          @openDialog="openDialogMedicamento"
          @closeDialog="closeDialogMedicamento"
          @updated="medicamentoUpdated"
          :rec="atualMedicamento"
        />
      </v-flex>
      <v-flex sm12 xs12 md10 mt-2>
        <h3>
          <b>Medicamentos</b>
        </h3>
      </v-flex>
    </v-layout>
    <v-container fluid v-if="registro.idRacao > 0">
      <v-data-iterator :items="listRacaoFarmaco" hide-default-footer>
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.cdFarmaco"
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <v-card hover>
                <v-card-title>
                  <h5>{{ item.farmaco.nmNome }}</h5>
                  <v-spacer />
                  <v-btn
                    id="editMedicamento"
                    @click="editarMedicamento(item)"
                    v-if="item.cdFarmaco != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-pen</v-icon>
                  </v-btn>
                  <v-btn
                    id="deleteMedicamento"
                    @click="removerMedicamento(item)"
                    v-if="item.cdFarmaco != 0"
                    text
                    icon
                    small
                    slot="activator"
                    style="margin: 0;"
                  >
                    <v-icon small color="#10303D">fas fa-trash-alt</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content class="caption">Identificador:</v-list-item-content>
                    <v-list-item-content class="align-end subtitle-2">{{ item.cdFarmaco }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption">Carência:</v-list-item-content>
                    <v-list-item-content
                      class="align-end subtitle-2"
                    >{{ item.farmaco.nrDiasCarencia }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption">Inicio da vigência:</v-list-item-content>
                    <v-list-item-content
                      class="align-end subtitle-2"
                    >{{ item.dtInicioVigencia | dateIsoToLocale }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="caption">Fim da vigência:</v-list-item-content>
                    <v-list-item-content
                      class="align-end subtitle-2"
                    >{{ item.dtFimVigencia | dateIsoToLocale }}</v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
    <v-layout pa-2 pr-8 pl-8>
      <v-flex>
        <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false" />
      </v-flex>
    </v-layout>
  </AppMainFormCard>
</template>

<script>
import {
  campoObrigatorio,
  campoSelectObrigatorio,
  tamanhoMaximoTrinta,
} from "@/filters/rules";
import {
  TituloShouldNavigate,
  MensagemShouldNavigate,
  MensagemSuccessSave,
} from "@/resourceMessageFile.js";

import AppMainFormCard from "@/components/layout/AppMainFormCard.vue";
import AppMainActionsButtonsForm from "@/components/layout/AppMainActionsButtonsForm.vue";
import DialogCadastroMedicamento from "@/components/dialogs/DialogCadastroMedicamento.vue";

export default {
  name: "Racao",
  components: {
    AppMainFormCard,
    AppMainActionsButtonsForm,
    DialogCadastroMedicamento,
  },
  data() {
    return {
      isFormValid: false,
      isEditing: false,
      isModified: false,
      registro: {},
      registroBanco: {},
      isLoading: false,
      stMedicada: false,
      dialogFarmaco: false,
      statusAtual: "",
      listaStatus: [
        { csStatus: "AT", dsStatus: "Ativa" },
        { csStatus: "IN", dsStatus: "Inativa" },
      ],
      listRacaoFarmaco: [],
      atualMedicamento: {},
      dialogMedicamento: false,
    };
  },
  computed: {
    farmacos() {
      return this.$store.state.farmacos;
    },
    tituloTela: {
      get() {
        if (this.isEditing) return "Ração: " + this.registro.idRacao;

        return "Inserindo nova Ração";
      },
    },
  },
  methods: {
    campoObrigatorio,
    campoSelectObrigatorio,
    tamanhoMaximoTrinta,
    selectMedicamentoInserted(farmaco) {
      this.listRacaoFarmaco.push(farmaco);
      if (this.registro.idRacao != 0) {
        this.updateRegistro();
      }
    },
    removerMedicamento(farmaco) {
      this.$root
        .$confirm(
          "Deseja Excluir Medicamento?",
          "O Medicamento será excluído permanentemente.",
          { color: "red", width: 400 }
        )
        .then((confirm) => {
          if (confirm) {
            this.changeViewState("isLoading");
            const index = this.listRacaoFarmaco.indexOf(farmaco);
            this.listRacaoFarmaco.splice(index, 1);
            if (this.registro.idRacao != 0) {
              this.updateRegistro();
            }
          }
        });
    },
    editarMedicamento(registro) {
      this.atualMedicamento = registro;
      this.dialogMedicamento = true;
    },
    closeDialogMedicamento() {
      this.atualMedicamento = {};
      this.dialogMedicamento = false;
    },
    openDialogMedicamento() {
      this.dialogMedicamento = true;
    },
    medicamentoUpdated() {
      this.updateRegistro();
    },
    changeViewState(status, value) {
      if (status == "isInserting") {
        this.isLoading = true;
        if (this.$refs.form != undefined) {
          this.$refs.form.reset();
        }
        this.carregarRegistrosLimpos();
        this.isLoading = false;
        this.isEditing = false;
        this.isModified = false;
      } else if (status == "isEditing") {
        this.isLoading = true;
        this.getRegistro(value);
        this.isEditing = true;
      } else if (status == "isError") {
        this.$store.commit("setSnack", { type: "error", msg: value });
        this.isLoading = false;
      } else if (status == "endLoading") {
        this.isLoading = false;
      } else if (status == "isLoading") {
        this.isLoading = true;
      }
    },
    initViewFromRoute(route) {
      this.$store.dispatch("actLoadFarmacos");
      if (route.params.id) {
        this.changeViewState("isEditing", route.params.id);
      } else {
        this.changeViewState("isInserting", null);
      }
    },
    getRegistro(id) {
      this.$axios
        .get("racao/" + id)
        .then((response) => {
          var rec = response.data[0].data;
          this.stMedicada = false;
          if (rec.lstRacaoFarmaco != null) {
            this.stMedicada = true;
            let farmacos = rec.lstRacaoFarmaco.map((entry) => {
              const cdFarmaco = entry.farmaco.idFarmaco;

              return Object.assign({}, entry, { cdFarmaco });
            });
            this.listRacaoFarmaco = farmacos;

            if (rec.flAtiva) {
              this.statusAtual = this.listaStatus.find(
                (i) => i.csStatus == "AT"
              );
            } else {
              this.statusAtual = this.listaStatus.find(
                (i) => i.csStatus == "IN"
              );
            }
          }
          this.registro = Object.assign({}, rec);
          this.registroBanco = Object.assign({}, rec);
          this.changeViewState("endLoading");
        })
        .catch((error) => {
          this.changeViewState("isError", error);
          this.$router.push({ path: "/racao" });
        });
    },
    saveRegistro() {
      if (this.$refs.form.validate()) {
        if (this.isEditing) {
          this.updateRegistro();
        } else {
          this.insertRegistro();
        }
      }
    },
    insertRegistro() {
      this.changeViewState("isLoading");
      this.registro.stMedicada = this.listRacaoFarmaco.length > 0 ? "S" : "N";
      this.registro.lstFarmaco = this.listRacaoFarmaco;
      if (this.statusAtual.csStatus != undefined) {
        this.registro.flAtiva =
          this.statusAtual.csStatus == "AT" ? true : false;
      } else {
        this.registro.flAtiva = this.statusAtual == "AT" ? true : false;
      }
      this.$axios
        .post("racao/", this.registro)
        .then((response) => {
          this.$router.replace({
            name: "racao",
            params: { id: response.data[0].data.idRacao },
          });
          this.$store.commit("setSnack", {
            type: "success",
            msg: MensagemSuccessSave,
          });
          this.changeViewState("endLoading");
          this.$store.dispatch("actLoadRacoes");
        })
        .catch((error) => {
          this.changeViewState("isError", error);
        });
    },
    updateRegistro() {
      this.changeViewState("isLoading");
      this.registro.stMedicada = this.listRacaoFarmaco.length > 0 ? "S" : "N";
      this.registro.lstFarmaco = this.listRacaoFarmaco;
      if (this.statusAtual.csStatus != undefined) {
        this.registro.flAtiva =
          this.statusAtual.csStatus == "AT" ? true : false;
      } else {
        this.registro.flAtiva = this.statusAtual == "AT" ? true : false;
      }
      this.$axios
        .put("racao/" + this.registro.idRacao, this.registro)
        .then(() => {
          this.$store.commit("setSnack", {
            type: "success",
            msg: MensagemSuccessSave,
          });
          this.initViewFromRoute(this.$route);
          this.$store.dispatch("actLoadRacoes");
        })
        .catch((error) => {
          this.changeViewState("isError", error);
        });
    },
    novoRegistro() {
      this.$router.push({ path: "/racao" });
    },
    carregarRegistrosLimpos() {
      this.registro = {
        idRacao: 0,
        nmRacao: "",
        cdItem: "",
        stMedicada: "",
        lstRacaoFarmaco: [],
        lstFarmaco: [],
      };
      this.registroBanco = {
        idRacao: 0,
        nmRacao: "",
        cdItem: "",
        stMedicada: "",
        lstRacaoFarmaco: [],
        lstFarmaco: [],
      };
    },
    beforeDeleteRegistro() {
      this.$root
        .$confirm(
          "Deseja Excluir?",
          "O registro será excluído permanentemente.",
          { color: "red", width: 400 }
        )
        .then((confirm) => {
          if (confirm) this.deleteRegistro();
        });
    },
    deleteRegistro() {
      this.changeViewState("isLoading");
      this.$axios
        .delete("racao/" + this.registro.idRacao)
        .then(() => {
          this.$router.go(-1);
          this.changeViewState("endLoading");
          this.$store.dispatch("actLoadracoes");
        })
        .catch((error) => {
          this.changeViewState("isError", error);
        });
    },
    goSearch() {
      this.$router.push({ path: "/racaoSearch" });
    },
    shouldNavigate(to, from, next) {
      if (
        JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) &&
        !this.isLoading
      ) {
        this.$root
          .$confirm(TituloShouldNavigate, MensagemShouldNavigate, {
            color: "red",
            width: 400,
          })
          .then((confirm) => {
            next(confirm);
            return confirm;
          });
      } else {
        next();
        return true;
      }
    },
    voltar() {
      this.$router.go(-1);
    },
  },
  watch: {
    $route(to) {
      this.initViewFromRoute(to);
    },
  },
  mounted() {
    this.initViewFromRoute(this.$route);
  },
  beforeRouteUpdate(to, from, next) {
    this.shouldNavigate(to, from, next);
  },
  beforeRouteLeave(to, from, next) {
    this.shouldNavigate(to, from, next);
  },
};
</script>

<style scoped>
.item {
  margin: 1px;
}
.marginTitle {
  margin: 15px;
}
.headerCard {
  color: white;
  background: #04222d;
  padding: 10px;
}
</style>
